// plugins/i18n-init.client.ts
import { defineNuxtPlugin } from '#app'
import { SystemLanguageEnum } from '~/types/const'
import { useCrossDomainCookie } from '@/composables/useCrossDomainCookie'
import { findKey, containsSubstring } from '~/utils/index'
import { convertLanguage } from '~/utils/format'

export default defineNuxtPlugin(async (nuxtApp) => {
  // 只在客户端执行
  if (process.client) {
    const { getCrossDomainCookie, createCrossDomainCookie } = useCrossDomainCookie()
    
    // 获取cookie中的语言设置
    const cookieLang = getCrossDomainCookie('lang')
    
    let currentLang: SystemLanguageEnum = SystemLanguageEnum.EN
    
    if (cookieLang.value) {
      // 如果cookie中有语言设置，直接使用
      currentLang = cookieLang.value as SystemLanguageEnum
      console.log("Using language from cookie:", currentLang)
    } else {
      // 如果cookie中没有语言设置，根据浏览器语言设置
      const browserLang = navigator.language || (navigator as any).browserLanguage
      const lanCode = findKey(convertLanguage, browserLang) || 'en'
      
      if (containsSubstring(lanCode, 'zh')) {
        // 根据具体值决定是简体中文还是繁体中文
        if (lanCode === 'zh-TW') {
          currentLang = SystemLanguageEnum.ZH_TW
        } else {
          currentLang = SystemLanguageEnum.ZH
        }
      } else {
        currentLang = lanCode as SystemLanguageEnum
      }
      
      // 检查语言是否支持
      const supportedLanguages = {
        "zh": true, 
        "en": true, 
        "ja": true, 
        "ko": true, 
        "zh-TW": true, 
        "hi": true, 
        "ar": true, 
        "de": true, 
        "fr": true, 
        "id": true, 
        "itb": true, 
        "uk": true
      }
      
      if (!supportedLanguages[currentLang as keyof typeof supportedLanguages]) {
        currentLang = SystemLanguageEnum.EN
      }
      
      // 将语言设置保存到cookie
      createCrossDomainCookie('lang', currentLang)
      console.log("Setting initial language from browser:", currentLang)
    }
    
    // 设置HTML lang属性
    if (process.client) {
      document.documentElement.lang = currentLang
    }
    
    // 将语言信息存储到nuxtApp的上下文中，供app.vue使用
    nuxtApp.provide('detectedLanguage', currentLang)
    
    console.log("Client-side language detected:", currentLang)
  }
})
